<!--
 * @Description: 项目执行人性别分布
 * @Date: 2024-01-11 13:52:40
-->
<template>
  <div class="bi-tmpl-detail__right__cmpt">
    <div
      v-if="curItem.tips"
      class="bi-tmpl-detail__right__cmpt__tips"
      style="margin-bottom: 6px"
    >
      {{ curItem.tips }}
    </div>

    <div>
      <span class="bi-tmpl-detail__right__cmpt__title" style="margin-top: 0">
        {{ curItem.title }}
      </span>
    </div>
    <Carousel ref="carouselRef" :itemHeight="200" :itemWidth="420 + 56">
      <div
        style="height: 200px; width: 100%"
        v-for="(item, index) in TYPE_MAPPING"
        :key="index"
        @click="onChange(item.value)"
      >
        <BaseCard style="width: 420px; height: 200px">
          <BaseRadio
            class="bi-tmpl-detail__right__cmpt__radio bi-tmpl-detail__right__cmpt__radio--w"
            :value="item.value"
            :model-value="curItem.value"
          >
            <component
              :colorList="colorList"
              style="margin-top: 20px"
              :is="cmpName(item.value)"
            />
          </BaseRadio>
        </BaseCard>
      </div>
    </Carousel>
  </div>
</template>

<script lang="ts" setup>
import { ref } from 'vue';
import { BaseRadio } from 'xrk-components';
import { BaseCard } from 'xrk-components';
import { useDetailCmpt } from '@V/bi-tmpl/src/hooks';
import { Carousel } from '@/components/base/carousel';
import PcModuleSex from '../../../../../bi-pc-module/pc-module-sex-distribution/index';

const CHILD_KEY = '4_2_1';
const TYPE_MAPPING = [1, 2, 3, 4, 5, 6, 7].map(i => {
  return {
    value: 'pc-module-sex-distribution-' + i,
    index: i
  };
});

const cmpName = name => {
  return PcModuleSex.filter(comp => comp.__name === name)[0];
};

const { curItem, onChange, state } = useDetailCmpt({ childKey: CHILD_KEY });

const colorList = ref(
  state.value.menuValue.get('101').value['101_1'].value.split(',')
);
</script>
<style lang="scss"></style>
